import { getTrackingMedium } from '@/frontend/src/helpers/tracking';
import type { ILocationResult } from '@/frontend/src/types/geo';
import type { ETracking } from '@/frontend/src/types/context';

type TProps = {
    context: string;
    ctaTargetUrl: string;
    locationResult: ILocationResult;
    tracking?: ETracking;
    isClosestLocation?: boolean;
};

export const getCtaTargetUrl = ({
    context,
    ctaTargetUrl,
    locationResult,
    tracking,
    isClosestLocation,
}: TProps): string => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (context === 'estimation_funnel') {
        ctaTargetUrl = `${ctaTargetUrl.replace(/\/?$/, '')}/address`;

        const { id, typeKey, postalCode, city, street, houseNumber } =
            locationResult;

        const params = {
            ...(id && { geo_id: id }),
            ...(postalCode && { zip: postalCode }),
            ...(city && { city_name: city }),
            ...(street && { street }),
            ...(houseNumber && { nr: houseNumber }),
        };

        const trackingMedium = getTrackingMedium(
            isClosestLocation ? 'CannotFindMyAddress' : typeKey,
            tracking,
        );

        const queryString = new URLSearchParams(params).toString();

        ctaTargetUrl += `?${queryString ? queryString + '&' : ''}${
            trackingMedium ? `m=${trackingMedium}` : ''
        }`;
    }

    return ctaTargetUrl;
};
